import apiClient from "./client";
import type {
  Project,
  ProjectDetail,
  ProjectListItem,
  CreateProjectRequest,
  UpdateProjectRequest,
  PipelineStatus,
  ProjectCurrentLoad,
} from "@/types/api";

export async function listProjects(): Promise<ProjectListItem[]> {
  const res = await apiClient.get<ProjectListItem[]>("/api/projects");
  return res.data;
}

export async function getProject(projectId: string): Promise<ProjectDetail> {
  const res = await apiClient.get<ProjectDetail>(`/api/projects/${projectId}`);
  return res.data;
}

export async function createProject(data: CreateProjectRequest): Promise<Project> {
  const res = await apiClient.post<Project>("/api/projects", data);
  return res.data;
}

/**
 * Clona o projeto (novo Draft, sem runs/decisões/aprovação nem carga do ex-kit; origem,
 * modo, janela e pacotes de demonstração vão junto). `name` opcional — em branco o
 * backend usa "{nome} (copy)".
 */
export async function duplicateProject(
  projectId: string,
  name?: string,
): Promise<Project> {
  const res = await apiClient.post<Project>(
    `/api/projects/${projectId}/duplicate`,
    name != null ? { name } : undefined,
  );
  return res.data;
}

export async function updateProject(
  projectId: string,
  data: UpdateProjectRequest,
): Promise<Project> {
  const res = await apiClient.patch<Project>(`/api/projects/${projectId}`, data);
  return res.data;
}

export async function deleteProject(projectId: string): Promise<void> {
  await apiClient.delete(`/api/projects/${projectId}`);
}

export async function getPipelineStatus(projectId: string): Promise<PipelineStatus> {
  const res = await apiClient.get<PipelineStatus>(
    `/api/projects/${projectId}/pipeline-status`,
  );
  return res.data;
}

/** A carga vigente do ex-kit e a que está chegando (#1785). */
export async function getProjectCurrentLoad(projectId: string): Promise<ProjectCurrentLoad> {
  const res = await apiClient.get<ProjectCurrentLoad>(`/api/projects/${projectId}/current-load`);
  return res.data;
}
